module.exports = __webpack_public_path__ + "img/setting-info.a210ef61.png";